import Chart from 'chart.js/auto'
import annotationPlugin from 'chartjs-plugin-annotation';

const selectors = {
  dashboard: '.m__dashboard-performance',
};

window.mce = 'mce' in window ? window.mce : {};
Chart.register(annotationPlugin);

/**
 * Setup IME # Status Card.
 */
export default function imeStatusCard(statusCard) {
  if (!statusCard) {
    return;
  }

  const dashboardEl = statusCard.closest(selectors.dashboard);
  const canvasEl = statusCard.querySelector('canvas');

  statusCard.chart = null;

  statusCard.load = async () => {
    destroyChart(statusCard.chart);
    console.log('Loading...');
    const params = {
      patient_status: statusCard.dataset.status,
      date_start: dashboardEl.getStartDate().toLocaleDateString(),
      date_end: dashboardEl.getEndDate().toLocaleDateString(),
      team: 0,
    };
    statusCard.chart = await loadChart(canvasEl.getContext('2d'), params);
  };

  statusCard.getTotalIME = () => totalIme;

  return statusCard;
}

/**
 * Create Chartjs chart object.
 *
 * @param {Object} ctx2d The 2D context to draw the chart.
 * @param {Object} params Object of parameters for the data load.
 */
async function loadChart(ctx2d, params) {
  const chartTitle = {
    display: false,
    text: '# IMEs',
  };
  const chartData = await loadData(params).then(jsonData => {
    const labels = [];
    const data = [];
    for (const [key, value] of Object.entries(jsonData.data_items)) {
      labels.push(key);
      data.push(value);
    }

    return {
      chartDataset: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: [
              'rgba(155, 136, 237, 1)',
              'rgba(251, 103, 202, 1)',
              'rgba(4, 191, 218, 1)',
              '#B540FD',
            ],
            hoverOffset: 12,
          },
        ],
      },
      chartCenter: {
        value: jsonData.total_ime,
        label: 'IME',
      },
    };
  });

  const chartLegend = {
    position: 'bottom',
    fullSize: true,
    align: 'start',
    labels: {
      usePointStyle: true,
      color: '#2B3AC4',
      font: {
        family: 'Open Sans',
        size: 16,
        weight: 'bold',
        lineHeight: 2,
      },
      padding: 20,
      textAlign: 'left',
      boxHeight: 13,
      generateLabels: chart => {
        const datasets = chart.data.datasets;
        return datasets[0].data.map((data, i) => ({
          text: `${data} ${chart.data.labels[i]}`,
          fillStyle: datasets[0].backgroundColor[i],
          lineWidth: 0,
          index: i,
        }))
      }
    },
  };

  const chartAnnotation = {
    annotations: {
      labelText: {
        type: 'label',
        xValue: 2.5,
        yValue: 60,
        yAdjust: -12,
        color: '#2B3AC4',
        backgroundColor: 'transparent',
        content: [
          chartData.chartCenter.label,
        ],
        font: {
          family: 'Open Sans',
          size: 21,
          weight: 'bold',
        },
      },
      labelValue: {
        type: 'label',
        xValue: 2.5,
        yValue: 60,
        yAdjust: 12,
        color: '#2B3AC4',
        backgroundColor: 'transparent',
        content: [
          chartData.chartCenter.value,
        ],
        font: {
          family: 'Open Sans',
          size: 21,
          weight: 'bold',
        },
      },
    },
  };

  const config = {
    type: 'doughnut',
    data: chartData.chartDataset,
    options: {
      responsive: true,
      cutout: '65%',
      // aspectRatio: 2,
      plugins: {
        legend: chartLegend,
        title: chartTitle,
        annotation: chartAnnotation,
      },
    },
  };

  return new Chart(ctx2d, config);
}

/**
 * Load chart data.
 *
 * @returns Promise for an array with chart data.
 */
async function loadData(params) {
  const url = new URL(window.location.origin + `${window.mce.api_url}ime/status/`);
  url.search = new URLSearchParams(params).toString();

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.mce.wpnonce,
    },
  })
    .then(response => response.json());
}

/**
 * Destroy Chart.
 * @param {Object} chart The chart instance.
 */
function destroyChart(chart) {
  if (chart) {
    chart.destroy();
  }
}
